import {Inject, Injectable} from '@angular/core';
import {LibConfig, LibConfigService} from '../lib.config';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base-service';
import {JavascriptLog} from '../_models/javascript-log';
import {Organization} from '../_models/organization';
import {OrganizationService} from './organization.service';

@Injectable({
    providedIn: 'root'
})
export class JavascriptLogService extends BaseService<JavascriptLog> {
    destination = 'javascript-logs';

    organization: Organization;

    constructor(
        private organizationService: OrganizationService,
        @Inject(LibConfigService) config: LibConfig,
        http: HttpClient
    ) {
        super(http, config);

        this.organizationService.current.subscribe(o => this.organization = o);
    }

    logAction(
        origin: string,
        action: string,
        message: string,
        success: boolean,
        actionDate = new Date()
    ) {
        console.log(new JavascriptLog({
                    parentId: this.organization.id,
                    organizationId: this.organization.id,
                    actionDate,
                    origin,
                    action,
                    message,
                    success
                }));
        // if (!!this.organization) {
        //     this.createSilent(new JavascriptLog({
        //         parentId: this.organization.id,
        //         organizationId: this.organization.id,
        //         actionDate,
        //         origin,
        //         action,
        //         message,
        //         success
        //     })).subscribe(() => {
        //     });
        // }
    }
}
